import Vue from 'vue'

import types from '../types'
import {Shape, ShapeGroup} from '../../interface'

const state: {
  list: Shape[],
  group: ShapeGroup[],
  scale: number
} = {
  list: [],
  group: [],
  scale: 0
}

const getters = {
}

const actions = {
}

const mutations = {
  [types.mutations.SHAPE_LIST](state: any, list: Shape[]): void {
    Vue.set(state, 'list', list)
  },
  [types.mutations.SHAPE_GROUP](state: any, group: ShapeGroup[]): void {
    Vue.set(state, 'group', group)
  },
  [types.mutations.SHAPE_SCALE](state: any, scale: number): void {
    Vue.set(state, 'scale', scale)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
